import { render, staticRenderFns } from "./CommentForm.vue?vue&type=template&id=d3fff896&scoped=true"
import script from "./CommentForm.vue?vue&type=script&lang=js"
export * from "./CommentForm.vue?vue&type=script&lang=js"
import style0 from "./CommentForm.vue?vue&type=style&index=0&id=d3fff896&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3fff896",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d3fff896')) {
      api.createRecord('d3fff896', component.options)
    } else {
      api.reload('d3fff896', component.options)
    }
    module.hot.accept("./CommentForm.vue?vue&type=template&id=d3fff896&scoped=true", function () {
      api.rerender('d3fff896', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Sector/Post/Card/CommentForm.vue"
export default component.exports